import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ListRelatedAds, {listRelatedAdsDisplay} from '@adv-mt/mt-list-related-ads'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {NEWS_DETAIL_EXTRA_INFO_BASE_CLASS} from '../config.js'
import {ListOffers} from './ListOffersSection.js'

const NEWS_DETAIL_EXTRA_INFO_ADS_BASE_CLASS = `${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}RelatedAds`

export const RelatedAdsSection = ({relatedAdsGroups, make, model, adsNew, adsRenting}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {OFFER_TYPE_NEW, OFFER_TYPE_SUBSCRIPTION} = config.get('search')
  const hasRelatedAds = Boolean(relatedAdsGroups?.length)
  const hasNewOffers = Boolean(adsNew?.length)
  const hasRentingOffers = Boolean(adsRenting?.length)

  return (
    <>
      {hasNewOffers && (
        <section>
          <ListOffers ads={adsNew} make={make} model={model} type={OFFER_TYPE_NEW} />
        </section>
      )}
      {hasRentingOffers && (
        <section>
          <ListOffers ads={adsRenting} make={make} model={model} type={OFFER_TYPE_SUBSCRIPTION} />
        </section>
      )}
      {hasRelatedAds &&
        relatedAdsGroups.map(({items, relatedAdsCollectionTitle}) => {
          return (
            <div className={NEWS_DETAIL_EXTRA_INFO_ADS_BASE_CLASS}>
              <div className={`${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}TitleWrapper`}>
                <TitleBasic title={relatedAdsCollectionTitle} as={titleBasicTags.h2} size={titleBasicSizes.s} />
              </div>
              <ListRelatedAds ads={items} display={listRelatedAdsDisplay.grid} itemsPerRow={4} />
            </div>
          )
        })}
    </>
  )
}

RelatedAdsSection.propTypes = {
  adsNew: PropTypes.array,
  adsRenting: PropTypes.array,
  make: PropTypes.string,
  model: PropTypes.string,
  relatedAdsGroups: PropTypes.array
}
